export class BookingLookup {
    accommodationId: number;

    firstName: string;
    lastName: string;
    email: string;
    telephone: string;

    checkIn: Date;
    checkOut: Date;

    postcode: string;
    hostPin: string;
}

